require('./usercard-view.component.scss');
import {
  ticksFormat
} from '../common/datetime';

const EVENT_TYPE2ID = {
  0: 'InterceptedFile',
  1: 'Keyboard',
  2: 'Run',
  3: 'Exit',
  4: 'Screenshot',
  5: 'NetworkConnection',
  6: 'AppInstallation',
  7: 'Web',
  8: 'Im',
  9: 'Mail',
  10: 'FTP',
  11: 'PrintDoc',
  12: 'UserLogon',
  13: 'Clipboard',
  14: 'Device',
  15: 'DiskDrive',
  16: 'FileOperation',
  17: 'SystemLog',
  18: 'UserActivity',
  19: 'UserTorturer',
  20: 'WebcamSnapshot',
  21: 'MicRecording',
  23: 'DevInventory',
  24: 'AppInventory',
  25: 'WebSearch',
  26: 'DesktopVideo',
  27: 'FormData',
  28: 'WLan',
  29: 'TTY',
  30: 'File',
  31: 'Admin',
  32: 'SCUD',
  33: 'LinuxLog',
  100500: 'Stat',
};


class UsercardViewController {
  constructor(
    $scope,
    UsercardService,
    $filter,
    $window
  ) {
    this.$scope = $scope;
    this.$filter = $filter;
    this.$window = $window;
    this.usercards = UsercardService;
    $scope.usercards = this.usercards;
    console.log('Hello from UsercardViewController');

    this.EVENT_TYPE2ID = EVENT_TYPE2ID;

    this.account_attrs = ['full_name', 'company', 'office', 'manager', 'post', 'comment', 'phone', 'mail', 'skype', 'www'];
    this.account_attrs_labels = {
      'full_name': 'Полное имя',
      'company': 'Организация',
      'office': 'Отдел',
      'manager': 'Руководитель',
      'phone': 'Телефон',
      'post': 'Должность',
      'comment': 'Комментарий',
      'mail': 'Почта',
      'skype': 'Скайп',
      'www': 'Сайт'
    };

    this.defaultWorktimeDailyStat = {
      labels: [],
      series: [],
    };

    this.defaultWorktimeStat = {
      labels: ['total', 'bonus', 'productive', 'neutral', 'unproductive', ''],
      series: [0, 0, 0, 0, 0],
    };

    this.defaultAppsStat = {
      labels: [],
      series: [],
    };

    this.chartOptions = {
      //         stackBars: true,
      height: '150px',
      horizontalBars: true,
      distributeSeries: true,
      axisY: {
        //             position: 'end',
        offset: 135,
        //             high: 60,
      },
      axisX: {
        //             offset: 100,
        scaleMinSpace: 60,
        labelInterpolationFnc: function(value) {
          return ticksFormat(value);
        },
        //             position: 'start',
      }
    };

    this.dailyChartOptions = {
      height: '120px',
      stackBars: true,
      axisY: {
        labelInterpolationFnc: ticksFormat,
        offset: 135,
      }
    };

    this.appsChartOptions = {
      //         height: '200px',
      //         stackBars: true,
      //         donut: true,
      //         startAngle: 270,
      //         donutSolid: true,
      height: '150px',
      horizontalBars: true,
      distributeSeries: true,
      axisY: {
        offset: 135,
      },
      axisX: {
        scaleMinSpace: 60,
        labelInterpolationFnc: ticksFormat,
        //             offset: 0,
      }
    };

    this.notes = '';

    this.$scope.$watch('$ctrl.usercards.selectedItem', () => {
      console.log('!!!!!!!!!!!! selectedItem changed !!!!!!!!!!!!');
      this.updateItem();
    });

  }

  visibleADAttrs() {
    return this.account_attrs.filter(attr => this.item.ad_attributes[attr]);
  }

  updateWorktimeStat(item) {
    if (item && item.stat && item.stat.categories) {
      const labels = this.defaultWorktimeStat.labels;
      const series = [];
      labels.forEach(l => series.push(item.stat.categories[l] ? item.stat.categories[l] : 0));
      series[0] = series.reduce((a, b) => a + b);
      //         console.log(series);
      this.worktimeStat = {
        labels: labels,
        series: series
      };
    } else {
      this.worktimeStat = this.defaultWorktimeStat;
    }
  }

  updateWorktimeDailyStat(item) {
    if (item && item.stat_list) {
      const labels = item.stat_list.map(i => this.$filter('date')(i.local_time, 'dd.MM'));
      //         console.log(labels);
      const series = [item.stat_list.map(stat => Object.values(stat.categories).reduce((a, b) => a + b, 0))];
      const cat_names = ['total', 'bonus', 'productive', 'neutral', 'unproductive'];
      const cat_series = [];
      for (let i = 0; i < cat_names.length; i++) {
        const cat_stat = [];
        item.stat_list.map(stat => cat_stat.push(stat.categories[cat_names[i]] ? stat.categories[cat_names[i]] : 0));
        cat_series.push(cat_stat);
      }
      this.worktimeDailyStat = {
        labels: labels,
        series: cat_series
      };
    } else {
      this.worktimeDailyStat = this.defaultWorktimeDailyStat;
    }
  }

  updateAppsStat(item) {
    if (item && item.stat && item.stat.apps) {
      const top = 4;
      const labels = Object.keys(item.stat.apps).slice(0, top);
      labels.push('others');
      labels.push('');
      const series = Object.values(item.stat.apps).slice(0, top);
      series.push(Object.values(item.stat.apps).slice(top).reduce((a, b) => a + b, 0));
      this.appsStat = {
        labels: labels,
        series: series
      };
      //         console.log(this.appsStat);
    } else {
      this.appsStat = this.defaultAppsStat;
    }
  }

  updateWebsStat(item) {
    if (item && item.stat && item.stat.webs) {
      const top = 4;
      const labels = Object.keys(item.stat.webs).slice(0, top);
      labels.push('others');
      labels.push('');
      const series = Object.values(item.stat.webs).slice(0, top);
      series.push(Object.values(item.stat.webs).slice(top).reduce((a, b) => a + b, 0));
      this.websStat = {
        labels: labels,
        series: series
      };
      //         console.log(this.websStat);
    } else {
      this.websStat = this.defaultAppsStat;
    }
  }

  updateItem() {
    this.toggleHeaderInfo = true;
    if (this.item != this.usercards.selectedItem) {
      // Set item
      this.item = this.usercards.selectedItem;
      // Update stats
      this.updateWorktimeStat(this.item);
      this.updateWorktimeDailyStat(this.item);
      this.updateAppsStat(this.item);
      this.updateWebsStat(this.item);
      // Update images
      this.item_image = '';
      this.image_index = undefined;
      this.select_image();
    }
  }

  select_image() {
    const shots_exists = this.item && this.item.photos && this.item.photos.length;
    if (shots_exists) {
      if (this.image_index == undefined) {
        this.image_index = 0;
      } else if (this.image_index + 1 < this.item.photos.length) {
        this.image_index += 1;
      } else {
        this.image_index = 0;
      }
    }
    this.item_image = this.image_index == undefined ? '/static/img/1.png' : 'media/' + this.item.photos[this.image_index];
  }

  changeNotes() {
    console.log(this.item.notes);
    console.log(this.item.full_name);
    this.usercards.saveItem(this.item.full_name, {
      'notes': this.item.notes
    });
  }

  build_ui_filter(attr, value) {
    let value_string = value;
    let dim = '';
    const time_range = this.item.last_event || this.item.last_event != 'null' ?
      '&timeFrom=' + this.item.last_event.split('+')[0] :
      '';
    let label = value;
    const f = [];
    const filter_by_full_name = {
      'dimension': 'agent_account@full_name:full_name',
      'value': this.item.full_name,
      'label': this.item.full_name
    };
    if (attr == 'computer') {
      value_string = value.id + 'ʻ' + value.hwid + 'ʻ' + value.computer_name;
      dim = 'agent_agent@computer_name:computer_name';
      label = value.computer_name;
      f.push(filter_by_full_name);
    }
    if (attr == 'user') {
      dim = 'agent_account@user_name:user_name';
    }
    if (attr == 'contact') {
      dim = 'agent_dialog@sender:sender';
    }
    if (attr == 'event_type') {
      dim = 'agent_eventtype@default:agent_eventtype';
      console.log(typeof(value));
      value_string = value.toString();
      label = EVENT_TYPE2ID[value];
      f.push(filter_by_full_name);
    }
    f.push({
      'dimension': dim,
      'value': value_string,
      'label': label
    });
    const query = '/#!/?barDim=' + dim + '&filters=' + JSON.stringify(f) + '&panel=constructor' + time_range;
    console.log(query);
    this.$window.open(query, '_blank');
  }
}

export function UsercardViewComponent() {
  return {
    restrict: 'E',
    template: require('./usercard-view.component.html'),
    scope: true,
    controller: UsercardViewController,
    controllerAs: '$ctrl',
    bindToController: {
      dim: '<',
      model: '<',
    },
  };
}



// WEBPACK FOOTER //
// ./src/usercard/usercard-view.component.js